<template>
  <div id="app">
    <Nav />
    <router-view v-wechat-title="$route.meta.title"></router-view>
    <Footer />
  </div>
</template>
<script>
import Nav from '@/components/common/nav';
import Footer from '@/components/common/footer';
import DevicePixelRatio from '@/utils/device'
export default {
  components: {
    Nav,
    Footer
  },
  created() {
    new DevicePixelRatio().init();
  },
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}
</style>
